import React from "react";
import { CustomText } from "../../../components";
import { fonts } from "../../../config";
import { masks } from "../../../utils";
import { StylesGuest, StylesForm } from "../styles";
import Grid from "@mui/material/GridLegacy";
import { SubmitButton } from "../../../components/newComponents";
import ReadOnlyFieldsView from "../../../components/newComponents/ReadOnlyFieldsView";

function VisitantForm({ data, onSubmit, viewOnly = false }: { data: any; onSubmit: (v: any) => void; viewOnly?: boolean }) {
  if (viewOnly) {
    const docType = data?.primaryGuest?.document ? 1 : data?.primaryGuest?.passport ? 2 : 1;
    const docValue = data?.primaryGuest?.document ?? data?.primaryGuest?.passport ?? "";
    const birthdayText = data?.primaryGuest?.birthDate ? masks.formatDate(data.primaryGuest.birthDate) : "-";

    return (
      <ReadOnlyFieldsView
        values={{
          fullName: data?.primaryGuest?.name,
          docType,
          docValue,
          birthdayText,
          email: data?.primaryGuest?.email,
          phone: data?.primaryGuest?.phone,
        }}
        showVehiclePlate={false}
        onConfirm={() => onSubmit({})}
      />
    );
  }

  return (
    <StylesForm.HeaderSteps>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            NOME COMPLETO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.name}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} md={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            DOCUMENTO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.document
              ? masks.CPF(data?.primaryGuest?.document)
              : data?.primaryGuest?.passport}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} md={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            E-MAIL
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.email}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        {data?.primaryGuest?.phone && (
          <Grid item xs={12} md={6}>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={1.75}
              fontFamily={fonts.semibold}
              textColor="#4D585A"
            >
              TELEFONE
            </CustomText>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={2}
              fontFamily={fonts.semibold}
              textColor="#24272A"
            >
              {masks.inputMaskTELWithDDD(data?.primaryGuest?.phone)}
            </CustomText>
            <StylesGuest.Line />
          </Grid>
        )}
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <SubmitButton fullWidth={false} type="button" onClick={() => onSubmit({})}>
          Confirmar
        </SubmitButton>
      </div>
    </StylesForm.HeaderSteps>
  );
}

export default VisitantForm;
